// Routes
export const ROUTE_PATHS = {
  HOME: '/',
};

// Types
export interface MealItem {
  name: string;
  amount: string;
}

export interface Meal {
  type: 'breakfast' | 'pre-workout' | 'post-workout' | 'snack' | 'dinner' | 'meal2' | 'meal3';
  label: string;
  emoji: string;
  items: MealItem[];
}

export interface DayPlan {
  day: string;
  dayAr: string;
  dayNum: number;
  meals: Meal[];
  totalProtein?: string;
  totalCarbs?: string;
  totalCalories?: string;
}
